<template>
  <div>
    <vue-loading v-if="loading"></vue-loading>
    <div v-else>
      <h2>Survey Volumes</h2>
      <div v-if="items.length > 0">
        <div class="row header">
          <div class="col-md-3 col-sm-12">
            <i class="fa fa-fw fa-paper-plane"></i>
            Modeway
          </div>
          <div class="col-md-3 col-sm-12">
            <i class="fa fa-fw fa-cubes"></i>
            Items
          </div>
          <div class="col-md-3 col-sm-12">
            <i class="fa fa-fw fa-cube"></i>
            Volume
          </div>
          <div class="col-md-3 col-sm-12">
            <i class="fa fa-fw fa-tachometer"></i>
            Weight
          </div>
        </div>
        <hr>
        <div v-for="modeVolume in volumesMatrix" class="row">
          <div class="col-md-3 col-sm-12">
            <span v-if="modeVolume.mode.color " class="mode-bullet" v-bind:style="{ backgroundColor: modeVolume.mode.color }"></span>
            <strong>{{ modeVolume.mode.text }}</strong>
          </div>
          <div class="col-md-3 col-sm-12">{{ modeVolume.count }} items</div>
          <div class="col-md-3 col-sm-12">{{ modeVolume.volume | formatFloat(2) }} {{ volumeUnit }}</div>
          <div class="col-md-3 col-sm-12">{{ modeVolume.weight | formatFloat(2) }} {{ weightUnit }}</div>
        </div>
        <hr>
        <div class="row summary">
          <div class="col-md-3 col-sm-12">Total</div>
          <div class="col-md-3 col-sm-12">{{ itemsTotal }} items</div>
          <div class="col-md-3 col-sm-12">{{ volumeTotal | formatFloat(2) }} {{ volumeUnit }}</div>
          <div class="col-md-3 col-sm-12">{{ weightTotal | formatFloat(2) }} {{ weightUnit }}</div>
        </div>
      </div>
      <div v-else>
        <em>Please register rooms and items to calculate the survey volumes.</em>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .header {
    font-weight: bold;
  }

  .summary {
    font-weight: bold;
  }

  .mode-bullet {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    border: 2px solid rgba(0,0,0,0.5);
    border-radius: 50%;
    margin-right: 0.5em;
    background-color: #ffffff;
    position: relative;
    top: 2px;
  }
</style>

<script>
  import { mapGetters } from 'vuex'
  import { EventBus } from '../../event-bus'

  export default {
    name: 'Volumes',
    props: [ 'surveyId' ],
    data: () => ({
      volumeTotal: 0,
      weightTotal: 0,
      itemsTotal: 0,
      volumesMatrix: [],
      loading: true,
      surveyItems: []
    }),
    mounted () {
      EventBus.$on('calculateVolumes', () => {
        this.updateVolumesMatrix()
      })
    },
    computed: {
      ...mapGetters({
        modes: 'getAllModes',
        items: 'getAllItems'
      }),
      volumeUnit () {
        if (this.$hasMetricUnits()) {
          return 'Cbm'
        } else {
          return 'Cuft'
        }
      },
      weightUnit () {
        if (this.$hasMetricUnits()) {
          return 'Kg'
        } else {
          return 'lbs'
        }
      }
    },
    created: function () {
      this.updateVolumesMatrix()
    },
    watch: {
      items: function () {
        this.updateVolumesMatrix()
      }
    },
    methods: {
      updateVolumesMatrix: function () {
        this.surveyItems = this.items.filter((item) => {
          return item.surveyId === this.surveyId
        })
        this.computeVolumesByModeWay()
        this.computeVolumeTotals()
      },
      computeVolumesByModeWay: function () {
        let matrix = []
        // loop modes
        let allModes = this.modes
        // add empty mode for items that have no mode specified
        if (!this.modes.filter((mode) => { return mode.id === null }).length) {
          allModes.push({
            id: null,
            text: 'Not specified'
          })
        }
        this.modes.forEach((mode) => {
          // filter items for mode
          let modeItems = this.surveyItems.filter((item) => {
            if (mode.id === null) { // no mode specified
              return (typeof item.mode === 'undefined' || item.mode === null || item.mode === false || item.mode === 0 || !item.mode)
            }
            return item.mode === mode.id
          })
          // compute count, volume and weight for mode
          let computation = modeItems.reduce((a, b) => {
            const n = Number(b.count)
            return { volume: Number(a.volume) + Number(b.volume) * n, weight: Number(a.weight) + Number(b.weight) * n, count: Number(a.count) + n }
          }, { volume: 0, weight: 0, count: 0 })
          // feed computation and mode into matrix
          matrix.push({
            mode: mode,
            volume: computation.volume,
            weight: computation.weight,
            count: computation.count
          })
        })
        // remove empty lines from matrix
        matrix = matrix.filter((modeVolume) => {
          return modeVolume.count > 0
        })
        // override component's volumesMatrix
        this.volumesMatrix = matrix
      },
      computeVolumeTotals: function () {
        let computation = this.surveyItems.reduce((a, b) => {
          const n = Number(b.count)
          return { volume: Number(a.volume) + Number(b.volume) * n, weight: Number(a.weight) + Number(b.weight) * n, count: Number(a.count) + n }
        }, { volume: 0, weight: 0, count: 0 })
        this.volumeTotal = computation.volume
        this.weightTotal = computation.weight
        this.itemsTotal = computation.count
        this.loading = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/children/Volumes.vue